import {
  DATA_SOURCE_KANBAN_GROUP_CARD_RENDER_LIMIT,
  DATA_SOURCE_KANBAN_GROUP_RENDER_LIMIT,
} from '../../core/data-source/window.js';
import type { Row } from '../../core/view-manager/row.js';

export type KanbanVisibleCardsWindow = {
  visibleCards: Row[];
  hiddenCount: number;
  totalCount: number;
};

export type KanbanVisibleGroupsWindow<T> = {
  visibleGroups: T[];
  hiddenCount: number;
  totalCount: number;
};

export function resolveKanbanVisibleGroups<T>(
  groups: readonly T[],
  limit: number = DATA_SOURCE_KANBAN_GROUP_RENDER_LIMIT
): KanbanVisibleGroupsWindow<T> {
  if (!Number.isInteger(limit) || limit <= 0) {
    throw new RangeError(
      'Kanban group render limit must be a positive integer'
    );
  }
  const visibleGroups = groups.slice(0, limit);
  return {
    visibleGroups,
    hiddenCount: groups.length - visibleGroups.length,
    totalCount: groups.length,
  };
}

export function resolveKanbanVisibleCards(
  groupRows: readonly Row[],
  rowRowIds: readonly string[] | undefined,
  limit: number = DATA_SOURCE_KANBAN_GROUP_CARD_RENDER_LIMIT
): KanbanVisibleCardsWindow {
  if (!Number.isInteger(limit) || limit <= 0) {
    throw new RangeError('Kanban card render limit must be a positive integer');
  }
  const rowSet = rowRowIds ? new Set(rowRowIds) : null;
  const cards = rowSet
    ? groupRows.filter(row => rowSet.has(row.rowId))
    : [...groupRows];
  const visibleCards = cards.slice(0, limit);

  return {
    visibleCards,
    hiddenCount: cards.length - visibleCards.length,
    totalCount: cards.length,
  };
}
